export enum WorkFlowStatus {
  DRAFT = 'DRAFT',
  WAIT = 'WAIT',
  FINISH = 'FINISH',
  CANCLE = 'CANCLE',
  EXPIRE = 'EXPIRE',
  REJECT = 'REJECT',
  FAIL = 'FAIL',
  ASSIGN = 'ASSIGN',
  NOT_NEED_FILE_COUNTER_SIGN = 'NOT_NEED_FILE_COUNTER_SIGN',
}

export const WorkFlowStatusMap = {
  [WorkFlowStatus.DRAFT]: '修改稿',
  [WorkFlowStatus.WAIT]: '待签字',
  [WorkFlowStatus.FINISH]: '已完成',
  [WorkFlowStatus.CANCLE]: '已撤回',
  [WorkFlowStatus.EXPIRE]: '已过期',
  [WorkFlowStatus.REJECT]: '已退回',
  [WorkFlowStatus.FAIL]: '已失败',
  [WorkFlowStatus.ASSIGN]: '已指派',
  [WorkFlowStatus.NOT_NEED_FILE_COUNTER_SIGN]: '无需会签',
};

export const WorkFlowHistoryStatusMap = {
  [WorkFlowStatus.DRAFT]: '草稿',
  [WorkFlowStatus.WAIT]: '待签',
  [WorkFlowStatus.FINISH]: '完成',
  [WorkFlowStatus.CANCLE]: '撤回',
  [WorkFlowStatus.EXPIRE]: '过期',
  [WorkFlowStatus.REJECT]: '退回',
  [WorkFlowStatus.FAIL]: '失败',
  [WorkFlowStatus.ASSIGN]: '指派',
  [WorkFlowStatus.NOT_NEED_FILE_COUNTER_SIGN]: '无需会签',
};

export const WorkFlowStatusList = [
  {
    label: '修改稿',
    value: WorkFlowStatus.DRAFT,
  },
  {
    label: '待签字',
    value: WorkFlowStatus.WAIT,
  },
  {
    label: '已完成',
    value: WorkFlowStatus.FINISH,
  },
  {
    label: '已撤回',
    value: WorkFlowStatus.CANCLE,
  },
  {
    label: '已过期',
    value: WorkFlowStatus.EXPIRE,
  },
  {
    label: '已退回',
    value: WorkFlowStatus.REJECT,
  },
  {
    label: '已失败',
    value: WorkFlowStatus.FAIL,
  },
  {
    label: '已指派',
    value: WorkFlowStatus.ASSIGN,
  },
  {
    label: '无需会签',
    value: WorkFlowStatus.NOT_NEED_FILE_COUNTER_SIGN,
  },
];

export const WorkFlowStatusHistoryList = [
  {
    label: '草稿',
    value: WorkFlowStatus.DRAFT,
  },
  {
    label: '待签',
    value: WorkFlowStatus.WAIT,
  },
  {
    label: '完成',
    value: WorkFlowStatus.FINISH,
  },
  {
    label: '撤回',
    value: WorkFlowStatus.CANCLE,
  },
  {
    label: '过期',
    value: WorkFlowStatus.EXPIRE,
  },
  {
    label: '退回',
    value: WorkFlowStatus.REJECT,
  },
  {
    label: '失败',
    value: WorkFlowStatus.FAIL,
  },
  {
    label: '指派',
    value: WorkFlowStatus.ASSIGN,
  },
  {
    label: '无需会签',
    value: WorkFlowStatus.NOT_NEED_FILE_COUNTER_SIGN,
  },
];

export enum WorkFlowNodeStatus {
  DRAFT = 'DRAFT',
  WAIT = 'WAIT',
  FILL_IN_FINISH = 'FILL_IN_FINISH',
  SIGN_FINISH = 'SIGN_FINISH',
  SEAL_FINISH = 'SEAL_FINISH',
  SIGN_SEAL_FINISH = 'SIGN_SEAL_FINISH',
  CANCLE = 'CANCLE',
  EXPIRE = 'EXPIRE',
  REJECT = 'REJECT',
  FAIL = 'FAIL',
  ASSIGN = 'ASSIGN',
  NOT_NEED_FILE_COUNTER_SIGN = 'NOT_NEED_FILE_COUNTER_SIGN',
}

export const WorkFlowNodeStatusMap = {
  [WorkFlowNodeStatus.DRAFT]: '草稿',
  [WorkFlowNodeStatus.WAIT]: '待签',
  [WorkFlowNodeStatus.FILL_IN_FINISH]: '提交',
  [WorkFlowNodeStatus.SIGN_FINISH]: '签字',
  [WorkFlowNodeStatus.SEAL_FINISH]: '盖章',
  [WorkFlowNodeStatus.SIGN_SEAL_FINISH]: '签章',
  [WorkFlowNodeStatus.CANCLE]: '撤回',
  [WorkFlowNodeStatus.EXPIRE]: '过期',
  [WorkFlowNodeStatus.REJECT]: '退回',
  [WorkFlowNodeStatus.FAIL]: '失败',
  [WorkFlowNodeStatus.ASSIGN]: '指派',
  [WorkFlowNodeStatus.NOT_NEED_FILE_COUNTER_SIGN]: '无需会签',
};

export const WorkFlowStatuNodeList = [
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.DRAFT],
    value: WorkFlowNodeStatus.DRAFT,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.WAIT],
    value: WorkFlowNodeStatus.WAIT,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.FILL_IN_FINISH],
    value: WorkFlowNodeStatus.FILL_IN_FINISH,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.SIGN_FINISH],
    value: WorkFlowNodeStatus.SIGN_FINISH,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.SEAL_FINISH],
    value: WorkFlowNodeStatus.SEAL_FINISH,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.SIGN_SEAL_FINISH],
    value: WorkFlowNodeStatus.SIGN_SEAL_FINISH,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.CANCLE],
    value: WorkFlowNodeStatus.CANCLE,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.EXPIRE],
    value: WorkFlowNodeStatus.EXPIRE,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.REJECT],
    value: WorkFlowNodeStatus.REJECT,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.FAIL],
    value: WorkFlowNodeStatus.FAIL,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.ASSIGN],
    value: WorkFlowNodeStatus.ASSIGN,
  },
  {
    label: WorkFlowNodeStatusMap[WorkFlowNodeStatus.NOT_NEED_FILE_COUNTER_SIGN],
    value: WorkFlowNodeStatus.NOT_NEED_FILE_COUNTER_SIGN,
  },
];
